<!--  -->
<template>
  <div>
    <div class="item1">
      <div @click="itemOpen()" class="flex" style="height: 50px">
        <div class="text-ellipsis item-title flex-1">
          <span>第一章 神经与中枢神经系统用药</span>
          <span class="over">已学完</span>
        </div>
        <div class="icon"><i class="el-icon-arrow-up"></i></div>
      </div>
      <div class="horizontal-line"></div>
      <!-- <transition name="plus-icon"> -->
      <div v-if="isOpen" class="item2">
        <div class="flex align-cente pt-1 pb-1 pl-06">
          <div class="circular flex-none">
            <div class="circular-left"></div>
            <!-- <div class="circular-right"></div> -->
          </div>
          <div
            class="flex text-ellipsis align-center w-100 font-smaller text-secondary ml-2"
          >
            <div class="flex text-ellipsis align-center flex-1">
              <span class="text-ellipsis">1-1 同分异构现象</span>
              <img
                src="@/assets/images/icon1_03.png"
                style="width: 14px; height: 15px; margin-left: 7px"
              />
            </div>
            <div class="mr-3"><span>45:00</span></div>
          </div>
        </div>
      </div>
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: true,
    };
  },
  methods: {
    itemOpen() {
      this.isOpen = this.isOpen ? false : true;
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
};
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>